import React from "react"
import { DatePicker, Button } from "antd"
import { Text } from "ui/Typography"
import dayjs from "dayjs"
import PropTypes from "prop-types"
import styles from "./index.module.css"

const DatePickerFilter = ({ selectedDate, onDateChange, onClear, soldOutDates }) => {
  const [open, setOpen] = React.useState(false)

  const disabledDate = (current) => {
    if (!current) return false
    const isPast = current < dayjs().startOf("day")
    const isSoldOut = soldOutDates.some((d) => current.isSame(dayjs(d, "YYYY-MM-DD"), "day"))
    return isPast || isSoldOut
  }

  const handleDateChange = (date) => {
    onDateChange(date)
    setOpen(false)
  }

  const handleClear = () => {
    onClear()
    setOpen(false)
  }

  return (
    <div className={styles.datePickerWrapper}>
      <Button shape="round" className={styles.datePickerBtn} onClick={() => setOpen((prev) => !prev)}>
        <Text className={styles.datePickerText}>
          {selectedDate ? `Date: ${dayjs(selectedDate).format("MMMM D, YYYY")}` : "Date"}
        </Text>
        <Text className={styles.datePickerIcon}>▼</Text>
      </Button>
      {open && (
        <div className={styles.datePickerPopup}>
          <DatePicker
            open={true}
            onOpenChange={(o) => {
              if (!o) setOpen(false)
            }}
            value={selectedDate ? dayjs(selectedDate, "YYYY-MM-DD") : null}
            onChange={handleDateChange}
            disabledDate={disabledDate}
            allowClear={true}
            suffixIcon={null}
            placeholder="Select date"
            className={styles.datePicker}
            popupClassName={styles.datePickerDropdown}
            showNow={false}
            format="MMMM D, YYYY"
            key={selectedDate ? "date-selected" : "date-not-selected"}
            renderExtraFooter={() => (
              <div className={styles.datePickerFooter}>
                <Button type="default" onClick={handleClear} className={styles.clearBtn}>
                  Clear
                </Button>
              </div>
            )}
          />
        </div>
      )}
    </div>
  )
}

DatePickerFilter.propTypes = {
  selectedDate: PropTypes.string,
  onDateChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  soldOutDates: PropTypes.arrayOf(PropTypes.string)
}

DatePickerFilter.defaultProps = {
  selectedDate: null,
  soldOutDates: []
}

export default DatePickerFilter
